<template>
  <div class="banner animate__animated animate__fadeIn">
    <mainHeader :bbid="bbid"
                :header_data="[{ title: '学习之旅', path: '/studyway' }, { title: $route.query.type },{ lxid: $route.query.lxid } ]"/>
    <div class="books">
      <div class="main">
        <el-carousel arrow="always" :interval="60000">
          <el-carousel-item v-for="(data, index) in list" :key="index">
            <div class="cardBox">
              <div class="box animate__animated animate__flipInX" :id="item.zid"
                   :style="'animation-delay:' + (indexItem*0.2 + 0.5) + 's'" v-for="(item, indexItem) in data"
                   :key="item.zid + '_' + indexItem">
                <div class="card">
                  <div class="img"
                       :class="'bookBg' + (indexItem % 5 + 1) + ' ' + (item.zt ? 'studied':'studying')"
                       :style="item.fm ? { backgroundImage: 'url(' + item.fm + ')' } : {}"></div>
                  <div class="bookRight">
                    <div class="bookMsg">
                      <div class="title">{{ item.zmc }}</div>
                      <div class="labels">
                        <div class="label">{{ item.cs }}词</div>
                        <div class="label">{{ item.gs }}关</div>
                      </div>

                      <!-- 进度条 -->
                      <div class="progress-wrapper" v-if="unitProgressMap[item.zid]">
                        <div class="progress-info">
                          <span class="progress-label">单元进度</span>
                          <span class="progress-text">{{ unitProgressMap[item.zid].completed }}/{{ unitProgressMap[item.zid].total }}</span>
                        </div>
                        <div class="progress-bar">
                          <div class="progress-fill"
                               :style="{ width: (unitProgressMap[item.zid].completed / unitProgressMap[item.zid].total * 100) + '%' }">
                          </div>
                        </div>
                      </div>

                      <div class="btn" @click="link(item)">{{ item.zt ? '继续学习' : '开始学习' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import mainHeader from "@/components/student/header";
import {isHaveZ,isHaveUnit} from '@/api/student'

export default {
  components: {
    mainHeader
  },
  data() {
    return {
      bbid: 0,
      list: [],
      unitProgressMap: {},
    }
  },
  created() {

  },
  methods: {
    link(data) {
      let jxInfo = JSON.parse(sessionStorage.getItem('jxInfo'))
      jxInfo.zid = data.zid
      jxInfo.zmc = data.zmc
      sessionStorage.setItem('jxInfo', JSON.stringify(jxInfo))
      const box = document.getElementById(data.zid)
      box.style.animationDelay = '0s'
      box.classList.add('animate__animated', 'animate__zoomOutRight')
      setTimeout(() => {
        this.$router.replace({
          name: 'units',
          query: {
            type: this.$route.query.type,
            bbid: this.$route.query.bbid,
            zid: data.zid,
            zmc: data.zmc,
            lxid: this.$route.query.lxid
          }
        })
      }, 800)
    },
    getBooks(bbid) {
      isHaveZ({
        bbid: bbid,
        bjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid,
        jxid: JSON.parse(sessionStorage.getItem('jxInfo')).jxid,
        yycdid: this.$store.state.yycdid,
        xsid: this.$store.state.userInfo.yhid
      }).then(res => {
        if (res.success) {
          if (res.result.length) {
            let arr = []
            res.result.forEach((ele, index) => {
              // 去掉章节名称末尾的数字后缀
              if (ele.zmc) {
                ele.zmc = ele.zmc.replace(/\d+$/, '')
              }
              if (!arr[parseInt(index / 6)]) {
                arr[parseInt(index / 6)] = []
              }
              arr[parseInt(index / 6)].push(ele)
              // 为每个章节获取进度
              this.getChapterProgress(ele.zid)
            })
            this.list = arr
          }
        } else {
          this.$message.error(res.resultDesc)
        }
      })
    },
    // 获取单个章节的单元进度
    async getChapterProgress(zid) {
    try {
      const res = await isHaveUnit({
        jxid: JSON.parse(sessionStorage.getItem('jxInfo')).jxid,
        xsid: this.$store.state.userInfo.yhid,
        zid: zid
      })
      if (res.success && res.result && res.result.length) {
        const units = res.result
        const total = units.length
        // 统计已完成的单元：有星级（xj > 0）表示已经学习/考试过
        const completed = units.filter(unit => unit.xj > 0).length

        this.$set(this.unitProgressMap, zid, {
          total: total,
          completed: completed
        })
      }
    } catch (error) {
      console.error('获取单元进度失败', error)
    }
  },
},
  mounted() {
    this.bbid = Number(this.$route.query.bbid)
    this.getBooks(this.bbid)
  },
  watch: {
    '$route.query.bbid'(newV, oldV) {
      this.bbid = Number(newV)
      this.getBooks(this.bbid)
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: url('../../../assets/images/student/booksbanner.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .main {
    width: 100%;
    position: absolute;
    top: 0px;
    bottom: 0px;

    .cardBox {
      position: absolute;
      top: 120px;
      bottom: 120px;
      left: 200px;
      right: 200px;

      .box {
        width: 33.3%;
        height: 49.9%;
        float: left;

        .card {
          background: #fff;
          width: calc(100% - 20px);
          height: calc(100% - 20px);
          margin: 10px;
          box-sizing: border-box;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.4);
          border-radius: 24px;
          padding: 20px;

          .img {
            float: left;
            width: 50%;
            height: 100%;
            border: 4px solid #5990ff;
            box-sizing: border-box;
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
            background-size: 100% 100%;
            position: relative;
          }

          .img::after {
            width: 50px;
            height: 70px;
            position: absolute;
            background-size: 100% 100%;
            color: #fff;
            font-size: 14px;
            font-weight: bold;
            box-sizing: border-box;
            line-height: 16px;
          }

          .img.studying::after {
            content: '未完成';
            background: url('../../../assets/images/student/tip_studying.png') no-repeat;
            top: -8px;
            right: -20px;
            padding: 5px 20px;
          }

          .img.studied::after {
            content: '已学完';
            background: url('../../../assets/images/student/tip_studied.png') no-repeat;
            top: -6px;
            right: -28px;
            padding-top: 5px;
            padding-left: 10px;
            padding-right: 20px;
          }

          .img.bookBg61 {
            background-image: url('../../../assets/images/student/book6上.png');
          }

          .img.bookBg62 {
            background-image: url('../../../assets/images/student/book6下.png');
          }

          .img.bookBg71 {
            background-image: url('../../../assets/images/student/book7上.png');
          }

          .img.bookBg72 {
            background-image: url('../../../assets/images/student/book7下.png');
          }

          .img.bookBg81 {
            background-image: url('../../../assets/images/student/book8上.png');
          }

          .img.bookBg82 {
            background-image: url('../../../assets/images/student/book8下.png');
          }

          .img.bookBg91 {
            background-image: url('../../../assets/images/student/book9上.png');
          }

          .img.bookBg92 {
            background-image: url('../../../assets/images/student/book9下.png');
          }

          .img.bookBg1 {
            background-image: url('../../../assets/images/student/book1.png');
          }

          .img.bookBg2 {
            background-image: url('../../../assets/images/student/book2.png');
          }

          .img.bookBg3 {
            background-image: url('../../../assets/images/student/book3.png');
          }

          .img.bookBg4 {
            background-image: url('../../../assets/images/student/book4.png');
          }

          .img.bookBg5 {
            background-image: url('../../../assets/images/student/book5.png');
          }

          .bookRight {
            float: left;
            width: 50%;
            height: 100%;
            position: relative;

            .bookMsg {
              width: 100%;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              padding: 1vh 0.5vw;
              box-sizing: border-box;

              .title {
                color: #000;
                font-size: 1.2vw;
                text-align: center;
                height: 8vh;
              }

              .labels {
                overflow: hidden;
                padding-top: 4vh;

                .label {
                  float: left;
                  width: 40%;
                  background: #4783CB;
                  margin: 0 5%;
                  font-size: 1vw;
                  color: #fff;
                  border-radius: 4px;
                  text-align: center;
                }
              }

              // 进度条样式 - 电脑端
              .progress-wrapper {
                margin: 12px 5% 8px;

                .progress-info {
                  display: flex;
                  justify-content: space-between;
                  font-size: 11px;
                  margin-bottom: 6px;

                  .progress-label {
                    color: #666;
                    font-size: 11px;
                  }

                  .progress-text {
                    color: #5990ff;
                    font-weight: bold;
                    font-size: 11px;
                  }
                }

                .progress-bar {
                  width: 100%;
                  height: 8px;
                  background-color: #e8e8e8;
                  border-radius: 4px;
                  overflow: hidden;

                  .progress-fill {
                    height: 100%;
                    background: linear-gradient(90deg, #5990ff, #8bb4ff);
                    border-radius: 4px;
                    transition: width 0.3s ease;
                  }
                }
              }

              .btn {
                background: #5990FF;
                color: #fff;
                width: 90%;
                font-size: 1.1vw;
                padding: 0.5vh 0;
                text-align: center;
                margin-left: 5%;
                margin-top: 2vh;
                border-radius: 20px;
                cursor: pointer;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
}

/* ========== 平板端适配样式（布局方式与电脑端一致，仅收窄边距防止挤压） ========== */
@media screen and (min-width: 768px) and (max-width: 1366px) {
  .banner {
    .main {
      .cardBox {
        top: 90px;
        bottom: 90px;
        left: 40px;
        right: 40px;
      }
    }
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 767px) {
  .banner {
    .main {
      .cardBox {
        top: 60px;
        bottom: 60px;
        left: 10px;
        right: 10px;
        overflow-y: auto;

        .box {
          width: 100%;
          height: auto;
          float: none;
          clear: both;

          .card {
            margin: 10px;
            padding: 14px;
            border-radius: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            min-height: 130px;
            box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.08);

            .img {
              width: 100px;
              height: 115px;
              float: none;
              border-radius: 12px;
              flex-shrink: 0;
            }

            .img::after {
              width: 38px;
              height: 52px;
              background-size: 100% 100%;
              font-size: 9px;
              line-height: 11px;
              top: -5px;
              right: -8px;
            }

            .img.studied::after {
              padding-top: 3px;
              padding-right: 10px;
            }

            .bookRight {
              width: auto;
              flex: 1;
              height: auto;
              float: none;
              padding-left: 14px;

              .bookMsg {
                position: static;
                transform: none;
                padding: 0;

                .title {
                  font-size: 15px;
                  height: auto;
                  text-align: left;
                  font-weight: bold;
                  margin-bottom: 6px;
                }

                .labels {
                  padding-top: 0;
                  display: flex;
                  justify-content: flex-start;
                  margin-bottom: 8px;

                  .label {
                    float: none;
                    width: auto;
                    margin: 0 8px 0 0;
                    font-size: 11px;
                    padding: 3px 10px;
                    border-radius: 16px;
                  }
                }

                // 进度条 - 手机端
                .progress-wrapper {
                  margin: 6px 0 10px;

                  .progress-info {
                    font-size: 10px;
                    margin-bottom: 4px;

                    .progress-label {
                      font-size: 10px;
                      color: #999;
                    }

                    .progress-text {
                      font-size: 10px;
                    }
                  }

                  .progress-bar {
                    height: 5px;
                    background-color: #f0f0f0;
                    border-radius: 2.5px;

                    .progress-fill {
                      border-radius: 2.5px;
                    }
                  }
                }

                .btn {
                  width: auto;
                  display: inline-block;
                  padding: 6px 18px;
                  font-size: 12px;
                  margin: 0;
                  margin-top: 6px;
                  text-align: center;
                  white-space: nowrap;
                  border-radius: 25px;
                }
              }
            }
          }
        }
      }
    }
  }
}

/* ========== 大屏桌面端（>1366px）保持原样 ========== */
@media screen and (min-width: 1367px) {
  .banner {
    .main {
      .cardBox {
        .box {
          .card {
            .bookRight {
              .bookMsg {
                .progress-wrapper {
                  margin: 12px 5% 8px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.books {
  .el-carousel {
    height: 100%;

    .el-carousel__container {
      height: 100%;
    }

    .el-carousel__arrow {
      background-color: transparent;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 100px;
      height: 100px;

      i {
        display: none;
      }
    }

    .el-carousel__arrow--left {
      left: 50px;
      background-image: url('../../../assets/images/student/tabLeftIcon.png');
    }

    .el-carousel__arrow--right {
      right: 50px;
      background-image: url('../../../assets/images/student/tabRightIcon.png');
    }

    .el-carousel__indicators {
      bottom: 60px;
    }

    .el-carousel__indicator {
      padding: 12px 15px;

      .el-carousel__button {
        width: 50px;
        height: 13px;
        border-radius: 6px;
        background: #fff;
        opacity: 1;
      }
    }

    .el-carousel__indicator.is-active {
      .el-carousel__button {
        background: #5990FF;
      }
    }
  }
}

/* 轮播图按钮平板/手机适配 */
@media screen and (max-width: 1366px) {
  .books {
    .el-carousel {
      .el-carousel__arrow {
        width: 40px;
        height: 40px;
      }

      .el-carousel__arrow--left {
        left: 10px;
      }

      .el-carousel__arrow--right {
        right: 10px;
      }

      .el-carousel__indicators {
        bottom: 15px;
      }

      .el-carousel__indicator {
        padding: 6px 8px;

        .el-carousel__button {
          width: 30px;
          height: 5px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .books {
    .el-carousel {
      .el-carousel__arrow {
        width: 32px;
        height: 32px;
      }

      .el-carousel__indicators {
        bottom: 8px;
      }

      .el-carousel__indicator {
        padding: 4px 5px;

        .el-carousel__button {
          width: 20px;
          height: 4px;
        }
      }
    }
  }
}
</style>


